import styles from './index.module.scss';
import { keepTwoNull } from '@/utils/utils';

type CardItemProps = {
  cardInfo: {
    name?: string;
    totalValue?: number;
    avgValue?: number;
    maxItem?: Item;
    minItem?: Item;
  };
  unit?: string;
  isTotal?: boolean;
};

interface Item {
  name?: string;
  value?: number;
}

const CardItem = ({ cardInfo, unit, isTotal }: CardItemProps) => {
  return (
    <div className={styles.cardBox}>
      {isTotal ? (
        <div className={`${styles.cardItem}`} style={{ height: '100%' }}>
          <div className={styles.label}>合计({unit ?? '--'}):</div>
          <div className={styles.totalValue}>{keepTwoNull(cardInfo.totalValue)}</div>
        </div>
      ) : (
        <div className={`${styles.cardItem}`}>
          <div>
            {cardInfo.name}({unit ?? '--'})<div className={styles.totalValue}>{keepTwoNull(cardInfo.totalValue)}</div>
          </div>
          <div className={styles.avgInfo}>
            <div>
              <span>最大用量({unit ?? '--'}):</span>
              <span>{keepTwoNull(cardInfo?.maxItem?.value)}</span>
              <span style={{ paddingLeft: 8 }}>({cardInfo.maxItem?.name ?? '--'})</span>
            </div>
            <div>
              <span>最小用量({unit ?? '--'}):</span>
              <span>{keepTwoNull(cardInfo?.minItem?.value)}</span>
              <span style={{ paddingLeft: 8 }}>({cardInfo?.minItem?.name ?? '--'})</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CardItem;
